import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BorrowerExternalCreditForm, showSuccess } from 'components';
import { deleteBorrowerExternalCredits } from 'services';
import { showApiError } from 'utils';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { externalCreditCardContainer, externalCreditInformationContainer, externalCreditActionsContainer, externalCreditActionIcon } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var BorrowerExternalCreditItem = function BorrowerExternalCreditItem(_ref) {
  var _data$creditor;

  var data = _ref.data,
      onDelete = _ref.onDelete,
      onEdit = _ref.onEdit;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isEdit = _useState2[0],
      setIsEdit = _useState2[1];

  var handleChange = function handleChange(data) {
    setIsEdit(false);
    _isFunction(onEdit) && onEdit(data);
  };

  var handleDelete = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$deleteBorrower, _yield$deleteBorrower2, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return deleteBorrowerExternalCredits(data === null || data === void 0 ? void 0 : data.id);

            case 2:
              _yield$deleteBorrower = _context.sent;
              _yield$deleteBorrower2 = _slicedToArray(_yield$deleteBorrower, 2);
              err = _yield$deleteBorrower2[1];
              err && showApiError(err);
              showSuccess('Прихода изтрит успешно.');
              _isFunction(onDelete) && onDelete(data === null || data === void 0 ? void 0 : data.id);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleDelete() {
      return _ref2.apply(this, arguments);
    };
  }();

  return ___EmotionJSX("div", {
    css: externalCreditCardContainer
  }, !isEdit ? ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    css: externalCreditInformationContainer
  }, ___EmotionJSX("div", {
    className: "externalCreditInfoCol"
  }, ___EmotionJSX("p", {
    className: "externalCreditInfoLabel"
  }, "\u041A\u0440\u0435\u0434\u0438\u0442\u043E\u0440"), ___EmotionJSX("p", {
    className: "externalCreditInfoText"
  }, (_data$creditor = data === null || data === void 0 ? void 0 : data.creditor) !== null && _data$creditor !== void 0 ? _data$creditor : 'N/A')), ___EmotionJSX("div", {
    className: "externalCreditInfoCol"
  }, ___EmotionJSX("p", {
    className: "externalCreditInfoLabel"
  }, "\u0420\u0430\u0437\u043C\u0435\u0440 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430"), ___EmotionJSX("p", {
    className: "externalCreditInfoText"
  }, data !== null && data !== void 0 && data.amount ? "".concat(data === null || data === void 0 ? void 0 : data.amount, " ").concat(data === null || data === void 0 ? void 0 : data.currency) : 'N/A')), ___EmotionJSX("div", {
    className: "externalCreditInfoCol"
  }, ___EmotionJSX("p", {
    className: "externalCreditInfoLabel"
  }, "\u041C\u0435\u0441\u0435\u0447\u043D\u0430 \u0432\u043D\u043E\u0441\u043A\u0430"), ___EmotionJSX("p", {
    className: "externalCreditInfoText"
  }, data !== null && data !== void 0 && data.monthly_payment ? "".concat(data === null || data === void 0 ? void 0 : data.monthly_payment, "  ").concat(data === null || data === void 0 ? void 0 : data.currency) : 'N/A'))), ___EmotionJSX("div", {
    css: externalCreditActionsContainer
  }, ___EmotionJSX(EditIcon, {
    css: externalCreditActionIcon,
    onClick: function onClick() {
      return setIsEdit(true);
    }
  }), ___EmotionJSX(DeleteIcon, {
    css: externalCreditActionIcon,
    onClick: handleDelete
  }))) : ___EmotionJSX(BorrowerExternalCreditForm, {
    data: data,
    onBorrowerChange: handleChange,
    onCancel: function onCancel() {
      return setIsEdit(false);
    }
  }));
};

BorrowerExternalCreditItem.propTypes = {
  data: PropTypes.object,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func
};
export default BorrowerExternalCreditItem;